<template>
  <a-drawer
    title="添加日志"
    :width="400"
    :visible="visible"
    @close="
      $emit('update:visible', false);
      form.resetFields();
    "
  >
    <a-form
      :form="form"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      @submit="handleOk"
    >
      <a-form-item label="巡查人员">
        <a-select
          v-decorator="[
            'name',
            {
              initialValue: '',
              rules: [{ required: true, message: '请选择巡查人员' }]
            }
          ]"
          placeholder="请选择巡查人员"
          option-filter-prop="children"
          showSearch
        >
          <a-select-option
            v-for="item in operationUserList"
            :key="item.id"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="巡查时间">
        <a-date-picker
          style="width: 100%;"
          placeholder="请选择巡查时间"
          v-decorator="[
            'time',
            { rules: [{ required: true, message: '请选择巡查时间' }] }
          ]"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        />
      </a-form-item>
      <a-form-item label="上传图片">
        <a-upload
          v-decorator="[
            'pic_urls',
            {
              rules: [{ required: true, message: '请上传图片' }],
              initialValue: fileList,
              valuePropName: 'pic_urls',
              getValueFromEvent: normFile
            }
          ]"
          multiple
          accept="image/*"
          :beforeUpload="beforeUploadFile"
          :customRequest="httpRequestFile"
          :remove="removeFile"
          list-type="picture-card"
          :file-list="fileList"
        >
          <div v-if="fileList.length < 3">
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上传图片
            </div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea v-decorator="['remark']" />
      </a-form-item>
    </a-form>

    <div class="drawer-btn">
      <a-button
        :style="{ marginRight: '8px' }"
        @click="
          $emit('update:visible', false);
          form.resetFields();
        "
      >
        取消
      </a-button>
      <a-button type="primary" @click="handleOk">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { addPollutantLog, ossUpload } from "@/api/api";
import { getUuid } from "@/utils/utils";
import moment from "moment";
import { OSS_PIC_BASE_URL } from "@/config/config";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      fileList: [],
      ossBaseUrl: OSS_PIC_BASE_URL
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "sensortypes",
      "groupTree",
      "alarmTypeList",
      "operationUserList"
    ]),
    ...mapGetters(["defaultInfo"])
  },
  methods: {
    moment,
    async httpRequestFile(info) {
      let file = info.file;
      try {
        let fileName = await ossUpload(getUuid(), file);
        this.fileList.push({
          uid: file.uid,
          name: fileName,
          status: "done",
          url:
            this.ossBaseUrl +
            fileName +
            "?x-oss-process=image/resize,m_fill,w_100,h_100"
        });
      } catch (error) {
        console.log(error);
      }
    },
    beforeUploadFile(file, fileList) {
      const isImage = file.type.startsWith("image/");
      // const isImage = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
      if (!isImage) {
        this.$message.error("请上传图片文件！");
      }
      return isImage; // 返回 true 允许上传 false 禁止上传
    },
    removeFile(file) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "确认删除此图片?",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.fileList = this.fileList.filter(x => x.name !== file.name);
            resolve();
          },
          onCancel: () => {
            this.$message.warning("取消删除");
            reject();
          }
        });
      });
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      const removedCount = e.fileList.filter(file => file.status === "removed")
        .length;
      if (e.fileList.length === removedCount) {
        return [];
      }
      return e && e.fileList;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        const params = {
          pollutant_id: this.record.id,
          name: values.name,
          time: values.time,
          pic_urls: this.fileList.map(x => x.name),
          remark: values.remark
        };

        try {
          let res = await addPollutantLog(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
          this.fileList = [];
        } catch (error) {
          this.$emit("update:visible", false);
          console.log(error);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
/deep/ .ant-upload-list-picture-card .ant-upload-list-item {
  padding: 0;
}
</style>
